import { deleteAsync, getAsync, patchAsync, postAsync } from "./http-client";

const AppConnectApi = {
  get: async (shopIdx) => {
    return await getAsync(`/shop/getAllAppsByShopIdx/${shopIdx}`);
  },
  edit: async (data) => {
    return await patchAsync("/shop/editAppConnect", data);
  },
  add: async (data) => {
    return await postAsync("/shop/deliveryAppConfirm", data);
  },
  delete: async (data) => {
    return await deleteAsync("/shop/deleteApp",data);
  },
};
export default AppConnectApi;
